import { Button, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { BsArrowLeft } from 'react-icons/bs';
import { FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ContentWrapper from '../widgets/ContentWrapper';

const { Text } = Typography;

const Onboarding = () => {
    const { t } = useTranslation('dashboard', { keyPrefix: 'ONBOARDING' });

    const navigate = useNavigate();

    return (
        <ContentWrapper title={t('WELCOME_TO_STUDY_GROUPS')}>
            <FaUsers color="#86C3FF" size={120} className="container__inner--icon-main" />
            <Text className="container__inner--text-help">
                <Trans
                    t={t}
                    i18nKey="HELP"
                    components={{
                        b: <b style={{ color: '#86C3FF' }} onClick={() => navigate('/groups/login')} />,
                    }}
                />
            </Text>
            <div className="container__inner--forms">
                <Button
                    block
                    type="primary"
                    size="large"
                    className="home__section--groups-button"
                    onClick={() => navigate('/groups/onboarding/create-group')}
                >
                    {t('GET_STARTED') }
                </Button>
            </div>

            <Text
                onClick={() => navigate('/')}
                className="steper__inner--back"
            >
                <BsArrowLeft size={16} color="#86C3FF" />
                {t('EXIT')}
            </Text>
        </ContentWrapper>
    );
};

export default Onboarding;
